<template>
  <div class="order-wrapper">
    <div class="top-info">
      <div class="icon">
        <img v-lazy="obj.headPortrait" alt="">
      </div>
      <div class="info-content">
        <div class="name">{{ obj.realname }}</div>
        <div class="hos">{{ obj.hospitalName }}</div>
        <div class="job">{{ obj.jobName }}</div>
      </div>
    </div>
    <div class="line"></div>
    <div class="time">
      <div>预约时间</div>
      <div class="time-info">{{ _getWeekDay(obj.week) }}&nbsp;{{ obj.time }}&nbsp;{{ obj.startTime }}</div>
    </div>
    <div v-if="obj.realname" class="bottom-info" @click="pay">点击完成预约</div>
  </div>
</template>

<script>
import { getOrderInfo, payOrder, payRechargeOrder } from '@/api/yuyueApi'
import { getUserId, getKey } from '@/common/js/cache'
let orderId = ''
export default {
  components: {},
  props: {},
  data () {
    return {
      obj: {}
    }
  },
  watch: {},
  computed: {},
  methods: {
    async pay() {
      if(getKey() === '~a01akcbbc7aaao'){ // 镁信健康
        this.payMxOrder()
      }else{
        this.payOrderByCard()
      }
    },
    async payMxOrder(){ 
      const params = {
        orderId,
        userId: getUserId()
      }
      const res = await payRechargeOrder(params)
      if (res.code === '9000200') {
        this.$router.replace({
          path: '/success',
          query: {
            orderId
          }
        })
      } else {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: res.message
        }).show()
      }
    },
    async payOrderByCard(){
      const params = {
        orderId
      }
      const res = await payOrder(params)
      if (res.code === '9000200') {
        this.$router.replace({
          path: '/success',
          query: {
            orderId: res.reason
          }
        })
      } else {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: res.message
        }).show()
      }
    },
    async getInfo () {
      const params = {
        orderId
      }
      const res = await getOrderInfo(params)
      this.obj = res.obj
    },
    _getWeekDay (num) {
      const weeks = {
        1: '周日',
        2: '周一',
        3: '周二',
        4: '周三',
        5: '周四',
        6: '周五',
        7: '周六'
      }
      return weeks[parseInt(num)]
    }
  },
  created () {
    orderId = this.$route.query.orderId
    if (!orderId) {
      this.$createDialog({
        type: 'alert',
        title: '缺少参数',
        content: 'orderId错误'
      }).show()
      return
    }
    this.getInfo()
  },
  mounted () {}
}
</script>
<style lang="stylus" scoped>
.order-wrapper {
  position absolute
  left 0
  top 0
  bottom 0
  right 0
  font-size 15px
  color white
  background-color #232829
  .top-info,.time {
    background-color #252a2b
    padding 20px
  }
  .top-info {
    display flex
    .icon {
      flex 0 0 90px
      width 90px
      img {
        width 70px
        height 70px
        object-fit: cover
        display block
        border-radius 5px
      }
    }
    .info-content {
      flex 1
      display flex
      flex-direction column
      justify-content space-between
    }
  }
  .line {
    height 1PX
    margin 0 20px
    background-color rgba(255,255,255, 0.1)
  }
  .time {
    display flex
    .time-info {
      flex 1
      text-align center
    }
  }
  .bottom-info {
    position absolute
    height 50px
    font-size 15px
    line-height 50px
    border-radius 30px
    text-align center
    bottom 50px
    left 10px
    right 10px
    background-color #fbf144
    color #4a4a4a
  }
}
</style>
